import { Hardware } from "@mui/icons-material";
import { Button, DatePicker, Grid, Input, Space } from "antd";
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PersonAddDisabledIcon from '@mui/icons-material/PersonAddDisabled';
import { formatPhoneNumber } from "../dummyConstant/DummyConstant";
import roleManager from "../roles";

import { ClockCircleOutlined, UploadOutlined } from "@ant-design/icons";
import moment from 'moment';

export const createColumns = (...params) => {
    let cols = params.map((col) => (col))
    return cols;
}


export const contractormap = (data) => {
    if (data) {
        const { firstName, lastName, Company } = data;
        let output = Company || "";
        if (Company && firstName && lastName) output += "-";
        if (firstName && lastName) output += ` ${firstName} ${lastName[0]}.`;
        return output;
    }
    return "";
};
export const addressTableHeader = ['Employee ID', 'Street Address', 'Street Address2', 'City , State', 'Zip Code', 'Edit']
export const TicketsTableHeader = ['Ticket ID', 'Name', 'Ticket/Alert', "Open Date", 'Department', 'Category', 'Description', 'View',]
export const HardwareTableHeader = ['Type', 'Manufacturer', 'Model Nbr', "Serial Nbr", 'Purchase Date', 'Attribute 1', 'Attribute 2','Retired Date', 'Status', 'Assigned To', "Edit"]
export const HardwareModalTableHeader = ['Type', 'Manufacturer', 'Model Nbr', "Serial Nbr", 'Purchase Date', 'Actions']
export const HardwareTableRows = [
    {
        type: "Type",
        manufacturer: "Manufacturer",
        modelNbr: "Model Number",
        serialNbr: "Serial Nbr",
        purchaseDate: "purchase Date",
        att1: "Attribute 1",
        att2: "Attribute 2",
        status: "Status",
        assignedTo: "Assigned To"
    }]


// export const TicketsTableHeader = [
//     { title: 'Ticket ID', dataIndex: 'ticketID', key: 'ticketID' },
//     { title: 'Name', dataIndex: 'name', key: 'name' },
//     { title: 'Ticket/Alerts', dataIndex: 'ticketAndAlerts', key: 'ticketAndAlerts' },
//     { title: 'Department', dataIndex: 'department', key: 'department' },
//     { title: 'Category', dataIndex: 'category', key: 'category' },
//     { title: 'Description', dataIndex: 'Description', key: 'Description', width: "20%" },
//     { title: 'View', dataIndex: 'view', key: 'view' },
//     { title: 'Complete', dataIndex: 'complete', key: 'complete' },
// ]


export const newHirequeTablee = () => {

    if (roleManager('newHireQueue', 'closeApplicant')) return ['Applicant', 'Department', 'City,ST', 'Email', 'Phone Number', 'Application Stage', 'View', 'Complete', 'Create Employee Record', 'Action'];
    if (roleManager('newHireQueue', 'changePassword')) return ['Applicant', 'Department', 'City,ST', 'Email', 'Phone Number', 'Application Stage', 'View', 'Complete', 'Create Employee Record', 'Actions'];
    else if (roleManager('newHireQueue', 'createEmployeeRecord')) return ['Applicant', 'Department', 'City,ST', 'Email', 'Phone Number', 'Application Stage', 'View', 'Complete', 'Create Employee Record'];
    return ['Applicant', 'Department', 'City,ST', 'Email', 'Phone Number', 'Application Stage', 'View', 'Complete']
}

export const certficateTableHeader = [' ID', 'License', 'Issue Date	', 'Expire Date', 'Edit']
export const positionTableHeader = [
    ' Full title',
    'Position Category',
    'Location',
    'CompCode',
    'Accounting JobCode',
    'Sub-Department',
    'Paycode',
    'Supervisor',
    'Start Date',
    ...(roleManager("employeeLookup", "sections", "positionButton") ? ['Edit'] : [""])
];

// export const positionTableHeader = [' Full title', 'Position Category	', 'Location	', 'CompCode', 'Accounting JobCode', 'Sub-Department', 'Paycode', 'Supervisor', 'Start Date	', 'Edit']
export const PayDetailsHeader = ['Pay Type', 'Pay Rate', 'Vehicle Allowance Amount', 'Rate Effective Date',
    ...(roleManager("employeeLookup", "sections", "PayDetails") ? ['Edit'] : [""])
]
export const ticketTableColumns = ["Ticket ID", "Name", "Tickets/Alerts", "Department", "Category", "Description", "View", "Complete"]
export const testingEventColumns = ["Event ID", "Date", "Time", "Location", "Job ID", "Rules", "Add Rules", "View Rules"];
export const testingEventColumnsDashboard = ["Event ID", "Date", "Time", "Evaluator", "Job ID", "Rules", "View Rules"];
export const checkRidesColumns = ["ID", "Engineer", "Type", "Evaluation Date", "Lead Locomotive", "TC Loads", "TC Empties", "TC Total Tonage", "Total Miles Traveled", "Score", "View"]
export const incidentTableColumns = ["Incident ID", "Date", "Time", "Location", "Incident Type", "View/Edit", "Attachments", "Open/Close"]
// export const AuditTableColumns = ["Event ID", "Date", "Time", "Location", "Sub Department", "Foreman/Supr", "Audit Type", "View","Export"]

export const columnsForView = [
    "ID",
    "Event ID",
    "Rule NBR",
    "Crew Member",
    "Result",
    "Comments"
];

export const hireITColumn = ["Ticket ID",
    "Name",
    "Department",
    "AD",
    "Computer",
    "Cell Phone",
    "Vehicle",
    "Fuel Card",
    "Edit",
    "Complete"]

export const broadcastCol = [
    "Sub-Department", "Location", "Date", "Subject", "Message"
]
export const dashTableCol = [
    "",
    // "Employee ID",
    "License Certification",
    "Issue Date",
    "Expire Date",
]
export const dashTableColOther = [
    "Type",
    "Make",
    "Model",
    "Serial Nbr",
    "Att 1",
]
export const hardWareTableRow = [
    "Hardware Name",
    "Action",
    "Assignment Date",
    "Assign To Other",
    "Type",
    "Edit"
]


export const ReasonsTerminat = [
    { title: 'Misc-Violation of Safety Policy' },
    { title: 'Misc-Violation of Company Pol' },
    { title: 'Misc-Violation of Drug Policy' },
    { title: 'Misc-Insubordination' },
    { title: 'Vol-No-call/No-show 3+ days' },
    { title: 'Vol-Medical issue' },
    { title: 'Vol-Quit' },
    { title: 'Other-Unable to perform job duties' },
    { title: 'Other-Poor work habits' },
    { title: 'Other-Excessive absenteeism' },
    { title: 'Other-Reduction in force' },
    { title: 'Other' }
];


export const HTDept = ["Name", "Title", "Number"]


export const YesNo = [
    { title: "Yes", value: true },
    { title: "No", value: false },
];

export const statuses = [
    { id: 1, title: "Approve", value: true },
    { id: 2, title: "Reject", value: false },
];

export const SecondApproval = [
    "Applicant", "Date of Application", "Department", "Home City, St", 'SSN', "Phone Number", "Email Address", "View"
]

export const SecondApprovalNewHireQueue = [
    "Applicant", "Date of Application", "Home City, St", "Phone Number", "Email Address", "Job ID/description", "Job Category"
]

export const Approval = [
    { title: "Approve", value: true },
    { title: "Reject", value: false },
];
export const FailPass = [{ title: "Pass" }, { title: "Fail" }];

export const ActionDropdown = [
    { value: "EmpAsssigned", label: "Employee Assigned" },
    { value: "MoveToInventory", label: "Move To Inventory" },
    { value: "Retired-EOL", label: "Retired-EOL" },
    { value: "SentForRepair", label: "Sent For Repair" },
    { value: "Retired-Lost/Stolen", label: "Retired-Lost/Stolen" },
    { value: "Retired-Broken", label: "Retired-Broken" },
    { value: "ContractorAssigned", label: "Contractor Assigned" },

]

export const AssignToOther = [
    { value: "TGS Inventory", label: "TGS Inventory" },
    { value: "Repair Vendor", label: "Repair Vendor" },

]
export const list_checkride_type = [
    { id: "eventRecorder", label: "Event Recorder" },
    { id: "performanceRide", label: "Performance Ride" },
    { id: "certification", label: "Certification Ride" },
    { id: "Simulator", label: "Simulator" },
]

export const checkRideKeyNames = [
    'LLOA',
    'LLOB',
    'LLOC',
    'ABOA',
    'ABOB',
    'ABOC',
    'ABOD',
    'DBOA',
    'DBOB',
    'DBOC',
    'IBA',
    'IBB',
    'MA',
    'MB',
    'RTA',
    'RTB',
    'RTC',
    'DPA',
    'DPB',
    'DPC',
    'DICS',
    'LMA',
    'LMB',
    'LMC',
    'LMD',
    'LME',
    'LMF',
    'ORA',
    'ORB',
    'ORC',
    'ORD',
    'ORE',
    'ORF',
    'ORG',
    'ORH',
    'ORI',
    'ORJ',
    'THA',
    'THB',
    'THC',
    'THD',
    'THE',
    'THF',
    'THG',
    'THH',
    'THI',
    'THJ',
    'THK',
    'THL',
    'THM',
    'THN',
    'THO',
    'THP',
]


export const utility = { loader: false }


export const tgsLocation = [
    { id: 1, title: "Approve", value: true },
    { id: 2, title: "Reject", value: false },
];

export const IncidentDropdowns = {
    REPORTABLE_RECORDABLE: [
        { id: 1, title: 'Reportable', value: "Reportable" },
        { id: 2, title: 'Recordable', value: "Recordable" },
        { id: 3, title: 'Non-Reportable', value: "Non-Reportable" },
    ],
    FRA_OSHA: [
        { id: 1, title: 'FRA', value: 'FRA' },
        { id: 2, title: 'OSHA', value: 'OSHA' },
        { id: 3, title: 'DOT', value: 'DOT' },
        { id: 4, title: 'EPA', value: 'EPA' },
        { id: 5, title: 'N/A', value: 'N/A' },
    ],
    CauseTypes: [
        { id: 1, title: 'Human Factor', value: 'Human Factor' },
        { id: 2, title: 'Track Caused', value: 'Track Caused' },
        { id: 3, title: 'Equipment Caused', value: 'Equipment Caused' },
        { id: 4, title: 'Misc', value: 'Misc' },
        { id: 5, title: 'Personal', value: 'Personal' },
    ],
    OpenClosed: [
        { id: 1, title: 'Open', value: 'Open' },
        { id: 2, title: 'Close', value: 'Close' },
    ],
    DirectionOfTravel: [
        { id: 1, title: 'North', value: 'North' },
        { id: 2, title: 'East', value: 'East' },
        { id: 3, title: 'South', value: 'South' },
        { id: 4, title: 'West', value: 'West' },
    ],
    MoveTypes: [
        { id: 1, title: 'Pull', value: 'Pull' },
        { id: 2, title: 'Shove', value: 'Shove' },
        { id: 3, title: 'Light Locomotive', value: 'Light Locomotive' },
    ]
}

export const incidentTypesOptions = [
    { id: 1, title: "Acts of God" },
    { id: 2, title: "Casualty" },
    { id: 3, title: "Collision(Impact)" },
    { id: 4, title: "Crossing Incident / Accident" },
    { id: 5, title: "Derailment" },
    { id: 6, title: "Environmental" },
    { id: 7, title: "Fire / Explosion" },
    { id: 8, title: "Injury" },
    { id: 9, title: "MVA" },
    { id: 10, title: "Near Miss" },
    { id: 11, title: "Organizational" },
    { id: 12, title: "Property Damage" },
    { id: 13, title: "Security" },
];

export const visibiltyIncident = [
    { id: 1, title: "Clear" },
    { id: 2, title: "Foggy" },
    { id: 3, title: "Smoky" },
    { id: 4, title: "Smog" },
    { id: 5, title: "Misty" },
    { id: 6, title: "Precipitation" },
    { id: 7, title: "Dusty" },
    { id: 8, title: "Snowy" },
];
export const TODIncident = [
    { id: 1, title: "Night" },
    { id: 2, title: "Day" },
    { id: 3, title: "Dawn" },
    { id: 4, title: "Dusk" },
];



export const newHireQueueRetrieving = (data, onClickView, handleClickOpen, setselectedApplicant, id) => {
    let mappedData = data?.map(col => [
        col?.id + " / " + col?.firstName + " " + col?.lastName,
        col?.SubDepartment?.name,
        col?.city + " , " + col?.state,
        col?.email,
        <div style={{ width: "100px" }}>{formatPhoneNumber(col?.homePhone)}</div>,
        col?.EmployeeStatus?.name,
        (col?.ApplicantStatusId === 3 || col.ApplicantStatusId === 6 || col.ApplicantStatusId === 5) ?
            <Button onClick={() => onClickView(col)} className={`ViewIcon`} ></Button>
            :
            <VisibilityOffIcon style={{ width: "100%", fontSize: "17px" }} />,
        <Grid style={{ marginLeft: "15px" }} className={` ${(col?.isCompleted) ? `completeTrue` : `CompleteIcon`}`}></Grid>,
        (roleManager('newHireQueue', 'createEmployeeRecord')) ? (col?.ApplicantStatusId === 9 && col?.Employee === false) ?
            <Button style={{ width: '100%' }} onClick={() => { handleClickOpen(); setselectedApplicant(col) }} className={`${(col.ApplicantStatusId === 9 && col?.Employee === false) && 'PersonAddIcon'}`} >
                <PersonAddIcon style={{ width: "100%", fontSize: "17px" }} />
            </Button>
            :
            <PersonAddDisabledIcon style={{ width: "100%", fontSize: "17px" }} /> : <></>,

    ])
    return mappedData
}


export const IncidentFormFields = (formFields, listings, empInvolvedInIncident) => {
    return {
        general: [
            // { type: 9, name: "Reporter", initial: `${currentUser?.firstName} ${currentUser?.lastName}`, isDisabled: true, keyName: '', className: 'mbolder' },
            { type: 2, label: "Incident Date", keyName: 'IncidentDate', initial: formFields?.IncidentDate },
            { type: 5, label: "Incident Time", keyName: 'IncidentTime', initial: formFields?.IncidentTime },
        ],
        location: [
            {
                type: 3, name: "TGS Location", key: 'title', options: listings?.locations || [], keyName: "LocationId",
                initial: formFields?.LocationId
            },
            { type: 9, name: "Specific Location", keyName: 'SpecificLocation', value: formFields.SpecificLocation },
            { type: 9, name: "Latitude", keyName: 'Latitude', value: formFields?.Latitude },
            { type: 9, name: "Longitude", keyName: 'Longitude', value: formFields?.Longitude },
        ],
        generalInfo: [
            { type: 3, name: "Department", key: 'title', options: listings?.department || [], keyName: "department", initial: formFields?.department },
            { type: 3, name: "Sub Department", key: 'title', options: listings?.subdepartment || [], keyName: "SubDepartmentId", initial: formFields?.SubDepartmentId },
            { type: 3, name: "Incident Type", key: 'Type', options: listings?.types, keyName: "IncidentTypeId", initial: formFields?.IncidentTypeId },
            { type: 3, name: "Classification", key: 'Class', options: listings?.classification, keyName: "ClassificationId" },
            { type: 9, name: "Rules Broken", keyName: 'RulesBroken', value: formFields?.RulesBroken },
            { type: 9, name: "Nature Of Incident", keyName: 'NatureOfIncident', initial: formFields?.NatureOfIncident },
            { type: 9, fieldType: 'number', name: "Temperature", keyName: 'Temperature', initial: formFields?.Temperature },
            { type: 3, name: "Visibility", key: 'title', options: visibiltyIncident, keyName: "Visibility", initial: formFields?.Visibility },
            { type: 3, name: "T.O.D", key: 'title', options: TODIncident, keyName: "TimeOfDay", initial: formFields?.TimeOfDay },
            { type: 8, name: "Sent for Drug/Alcohol", keyName: "DrugAlcoholTest", state: formFields, initial: formFields?.DrugAlcoholTest },
            { type: 8, name: "Pictures Taken ?", keyName: "PicturesTaken", state: formFields, initial: formFields?.PicturesTaken },
            { type: 8, name: "Injury", keyName: "Injury", state: formFields, initial: formFields?.Injury },
            { type: 8, name: "Human Failure ?", keyName: "HumanFailure", state: formFields, initial: formFields?.HumanFailure },
            { type: 8, name: "Fatigue a Factor ?", keyName: "FatigueAFactor", state: formFields, initial: formFields?.FatigueAFactor },
            { type: 8, name: "Rule Violation", keyName: "RuleViolation", state: formFields, initial: formFields?.RuleViolation },
            { type: 8, name: "Supervisor Notified ?", keyName: "SupervisorNotified", state: formFields, initial: formFields?.SupervisorNotified },
            { type: 8, name: "Rail Incident", keyName: "RailIncident", state: formFields, initial: formFields?.RailIncident },
        ],
        railRoad: {
            general: [
                { type: 9, name: "Job ID", keyName: 'JobId', initial: formFields?.RailIncidents?.length ? formFields?.RailIncidents[0]?.JobId : "" },
                { type: 9, name: "Total HAZMAT Cars", keyName: 'TotalHAZMATCars', initial: formFields?.RailIncidents?.length ? formFields?.RailIncidents[0]?.TotalHAZMATCars : "" },
                { type: 9, name: "Total Cars", keyName: 'totalCars', initial: formFields?.RailIncidents?.length ? formFields?.RailIncidents[0]?.totalCars : "" },
                { type: 9, name: "HAZMAT Cars Derailed/Damaged", keyName: 'HAZMATCarsDerailOrDamaged', initial: formFields?.RailIncidents?.length ? formFields?.RailIncidents[0]?.HAZMATCarsDerailOrDamaged : "" },
                { type: 9, name: "Loads", keyName: 'Loads', initial: formFields?.RailIncidents?.length ? formFields?.RailIncidents[0]?.Loads : "" },
                { type: 9, name: "HAZMAT Cars Released/Spilled", keyName: 'HAZMATCarsReleasedOrSpilled', initial: formFields?.RailIncidents?.length ? formFields?.RailIncidents[0]?.HAZMATCarsReleasedOrSpilled : "" },
                { type: 9, name: "Empties", keyName: 'Empties', initial: formFields?.RailIncidents?.length ? formFields?.RailIncidents[0]?.Empties : "" },
                { type: 9, name: "Locomotive Nbrs", keyName: 'locomotiveNum', initial: formFields?.RailIncidents?.length ? formFields?.RailIncidents[0]?.locomotiveNum : "" },
                { type: 9, name: "Railcar Equip Nbrs", keyName: 'RailcarEquipNums', initial: formFields?.RailIncidents?.length ? formFields?.RailIncidents[0]?.RailcarEquipNums : "" },
                {
                    type: 8, name: "Safety Employee Notified", keyName: "employeesNotified", state: formFields?.RailIncidents?.length ? formFields?.RailIncidents[0] : {},
                    initial: formFields?.RailIncidents?.length ? formFields?.RailIncidents[0]?.employeesNotified : ""
                },
                { type: 2, name: "Notified Date", keyName: 'notifiedDate', initial: new Date() },
                { type: 5, name: "Notified Time", keyName: 'notifiedTime', initial: formFields?.RailIncidents?.length ? formFields?.RailIncidents[0]?.notifiedTime : "" },
                { type: 12, name: "Apparent Cause", keyName: 'ApparentCause', initial: formFields?.RailIncidents?.length ? formFields?.RailIncidents[0]?.ApparentCause : "", state: formFields?.RailIncidents?.length ? formFields?.RailIncidents[0] : {} },
            ],
            movement: [
                { type: 9, fieldType: 'number', name: "Approximate Speed (MPH)", keyName: 'approxSpeed', initial: formFields?.RailIncidents?.length ? formFields?.RailIncidents[0]?.approxSpeed : "" },
                {
                    type: 3, name: "Direction Of Travel", key: 'title', options: IncidentDropdowns?.DirectionOfTravel, keyName: "travelDirection",
                    initial: formFields?.RailIncidents?.length ? formFields?.travelDirection : ""
                },
                {
                    type: 3, name: "Move Type", key: 'title', options: IncidentDropdowns?.MoveTypes, keyName: "moveType",
                    initial: formFields?.RailIncidents?.length ? formFields?.moveType : ""
                },
            ],
            crew: [
                { type: 9, name: "Hours On Duty", keyName: 'HoursOnDuty', typography: "Format: 4 hours 30 minutes = 4.30", initial: formFields?.RailIncident ? formFields?.RailIncidents[0]?.HoursOnDuty : "" },
                { type: 9, name: "Crew Location at time of Incident", keyName: 'CrewLocationAtIncident', initial: formFields?.RailIncident ? formFields?.RailIncidents[0]?.CrewLocationAtIncident : "" },
                { type: 9, name: "What was taking place ?", keyName: 'CrewActivityAtIncident', initial: formFields?.RailIncident ? formFields?.RailIncidents[0]?.CrewActivityAtIncident : "" },
            ],
            rerail: [
                { type: 9, name: "Re-railing Crew Name", keyName: 'rerailingCrewName', initial: formFields?.RailIncident ? formFields?.RailIncidents[0]?.rerailingCrewName : "" },
                { type: 5, name: "Time Called", keyName: 'timeCalled', initial: formFields?.RailIncidents?.length ? formFields?.RailIncidents[0]?.timeCalled : "" },
                { type: 5, name: "Time Arrive", keyName: 'timeArrived', initial: formFields?.RailIncidents?.length ? formFields?.RailIncidents[0]?.timeArrived : "" },
                { type: 5, name: "Released", keyName: 'timeReleased', initial: formFields?.RailIncidents?.length ? formFields?.RailIncidents[0]?.timeReleased : "" },
                { type: 12, name: "Re-Rail Method", keyName: 'rerailMethod', initial: formFields?.RailIncidents?.length ? formFields?.RailIncidents[0]?.rerailMethod : "", state: formFields?.RailIncidents?.length ? formFields?.RailIncidents[0] : {} },
            ]
        },
        approver: [
            { type: 3, name: "Open/Close", key: 'title', options: IncidentDropdowns?.OpenClosed, keyName: "Open_Closed", initial: formFields?.Open_Closed },
            { type: 9, fieldType: 'number', name: "Total Cost", keyName: 'totalCost', initial: formFields?.totalCost },
            { type: 3, name: "Reportable/Recordable", key: 'title', options: tgsLocation, keyName: "reportableRecordable", initial: formFields?.reportableRecordable },
            { type: 3, name: "FRA/OSHA", key: 'title', options: IncidentDropdowns?.FRA_OSHA, keyName: "FRAOSHA", initial: formFields?.FRAOSHA },
            { type: 3, name: "Cause Code", key: 'title', options: tgsLocation, keyName: "causeCode", initial: formFields?.causeCode },
            { type: 3, name: "Cause Type", key: 'title', options: IncidentDropdowns?.CauseTypes, keyName: "causeType", initial: formFields?.causeType },
            { type: 9, name: "Approved By", keyName: 'totalCost', initial: formFields?.totalCost },
            { type: 2, name: "Approaved Date", keyName: 'approavedDate', initial: formFields?.approavedDate || new Date() },
            { type: 6, name: "Corrective Actions", keyName: 'correctiveActions', initial: formFields?.correctiveActions },
            { type: 6, name: "Approver Summary", keyName: 'approverSummary', initial: formFields?.approverSummary },
        ],
        employeeInvolved: [
            { type: 3, name: "Name", key: 'firstName', options: listings?.employees, keyName: "Name" },
            { type: 9, name: "Position", keyName: 'Position', },
            { type: 11, name: "Hired Last 6 Months", keyName: "Hired6Months", state: empInvolvedInIncident },
            { type: 6, name: "Notes", keyName: 'Notes', state: empInvolvedInIncident },
        ]
    }
}


export const fieldsAntd = (locations, departments, classification, subDepartment, setRailIncident, fetchSubDepartments, fetchClassifications, types) => {
    return {
        general: [
            { type: 2, label: "Incident Date", keyName: 'IncidentDate' },
            { type: 4, label: "Incident Time", keyName: 'IncidentTime' },
        ],
        location: [
            { type: 3, label: "TGS Location", options: locations || [], keyName: "LocationId", placeholder: "TGS Location" },
            { type: 1, label: "Specific Location", keyName: 'SpecificLocation', placeholder: "Specific Location" },
            { type: 1, label: "Latitude", keyName: 'Latitude', placeholder: "Latitude", validation: /^[\d]*\.?[\d]*$/g },
            { type: 1, label: "Longitude", keyName: 'Longitude', placeholder: "Longitude", validation: /^[\d]*\.?[\d]*$/g },
        ],
        generalInfo: [
            { type: 3, label: "Department", options: departments || [], keyName: "department", onChange: (value) => fetchSubDepartments(value), placeholder: "Department" },
            { type: 3, label: "Sub Department", options: subDepartment || [], keyName: "SubDepartmentId", placeholder: "Sub Department" },
            { type: 3, label: "Incident Type", options: types, keyName: "IncidentTypeId", placeholder: "Incident Type", onChange: (value) => fetchClassifications(value) },
            { type: 3, label: "Classification", options: classification, keyName: "ClassificationId", placeholder: "Classification" },
            { type: 1, label: "Rules Broken", keyName: 'RulesBroken', validation: /^[0-9.,]+$/g, placeholder: "Rules Broken" },
            { type: 1, label: "Nature Of Incident", keyName: 'NatureOfIncident', placeholder: "Nature Of Incident" },
            { type: 6, label: "Temperature", keyName: 'Temperature', placeholder: "Temperature" },
            { type: 3, label: "Visibility", key: 'title', options: visibiltyIncident, keyName: "Visibility", placeholder: "Visibility" },
            { type: 3, label: "T.O.D", key: 'title', options: TODIncident, keyName: "TimeOfDay", placeholder: "T.O.D" },
            { type: 7, label: "Sent for Drug/Alcohol", keyName: "DrugAlcoholTest", },
            { type: 7, label: "Pictures Taken ?", keyName: "PicturesTaken", },
            { type: 7, label: "Injury", keyName: "Injury", },
            { type: 7, label: "Human Failure ?", keyName: "HumanFailure", },
            { type: 7, label: "Fatigue a Factor ?", keyName: "FatigueAFactor", },
            { type: 7, label: "Rule Violation", keyName: "RuleViolation", },
            { type: 7, label: "Supervisor Notified ?", keyName: "SupervisorNotified", },
            { type: 7, label: "Rail Incident", keyName: "RailIncident", onChange: (value) => setRailIncident(value) },
        ],
        railRoad: {
            general: [
                { type: 1, placeholder: "Job ID", label: "Job ID", keyName: ["RailIncidentData", 'JobId'] },
                { type: 1, placeholder: "Total HAZMAT Cars", label: "Total HAZMAT Cars", keyName: ["RailIncidentData", 'TotalHAZMATCars'] },
                { type: 1, placeholder: "Total Cars", label: "Total Cars", keyName: ["RailIncidentData", 'totalCars'] },
                { type: 1, placeholder: "HAZMAT Cars Derailed/Damaged", label: "HAZMAT Cars Derailed/Damaged", keyName: ["RailIncidentData", 'HAZMATCarsDerailOrDamaged'] },
                { type: 1, placeholder: "Loads", label: "Loads", keyName: ["RailIncidentData", 'Loads'] },
                { type: 1, placeholder: "HAZMAT Cars Released/Spilled", label: "HAZMAT Cars Released/Spilled", keyName: ["RailIncidentData", 'HAZMATCarsReleasedOrSpilled'] },
                { type: 1, placeholder: "Empties", label: "Empties", keyName: ["RailIncidentData", 'Empties'] },
                { type: 1, placeholder: "Locomotive Nbrs", label: "Locomotive Nbrs", keyName: ["RailIncidentData", 'locomotiveNum'] },
                { type: 1, placeholder: "Railcar Equip Nbrs", label: "Railcar Equip Nbrs", keyName: ["RailIncidentData", 'RailcarEquipNums'] },
                { type: 7, label: "Safety Employee Notified", keyName: ["RailIncidentData", "employeesNotified"] },
                { type: 2, label: "Notified Date", keyName: ["RailIncidentData", 'notifiedDate'], },
                { type: 4, label: "Notified Time", keyName: ["RailIncidentData", 'notifiedTime'], },
                { type: 5, label: "Apparent Cause", keyName: ["RailIncidentData", 'ApparentCause'], placeholder: "Apparent Cause" },
            ],
            movement: [
                { type: 6, label: "Approximate Speed (MPH)", keyName: ["RailIncidentData", 'approxSpeed'], placeholder: "Approximate Speed (MPH)" },
                { type: 3, label: "Direction Of Travel", key: 'title', options: IncidentDropdowns?.DirectionOfTravel, keyName: ["RailIncidentData", "travelDirection"] },
                { type: 3, label: "Move Type", key: 'title', options: IncidentDropdowns?.MoveTypes, keyName: ["RailIncidentData", "moveType"] },
            ],
            crew: [
                { type: 4, label: "Hours On Duty", keyName: ["RailIncidentData", 'HoursOnDuty'] },
                { type: 1, label: "Crew Location at time of Incident", keyName: ["RailIncidentData", 'CrewLocationAtIncident'] },
                { type: 1, label: "What was taking place ?", keyName: ["RailIncidentData", 'CrewActivityAtIncident'] },
            ],
            rerail: [
                { type: 1, label: "Re-railing Crew Name", keyName: ["RailIncidentData", 'rerailingCrewName'] },
                { type: 4, label: "Time Called", keyName: ["RailIncidentData", 'timeCalled'], },
                { type: 4, label: "Time Arrive", keyName: ["RailIncidentData", 'timeArrived'], },
                { type: 4, label: "Released", keyName: ["RailIncidentData", 'timeReleased'], },
                { type: 5, label: "Re-Rail Method", keyName: ["RailIncidentData", 'rerailMethod'] },
            ]
        },
        approver: [
            { type: 3, label: "Open/Close", key: 'title', options: IncidentDropdowns?.OpenClosed, keyName: "Open_Closed" },
            { type: 6, label: "Total Cost", keyName: 'TotalCost' },
            { type: 3, label: "Reportable/Recordable", key: 'title', options: IncidentDropdowns?.REPORTABLE_RECORDABLE, keyName: "Reportable_Recordable" },
            { type: 3, label: "FRA/OSHA", key: 'title', options: IncidentDropdowns?.FRA_OSHA, keyName: "FRA_OSHA" },
            { type: 3, label: "Cause Code", key: 'title', options: tgsLocation, keyName: "CauseCode" },
            { type: 3, label: "Cause Type", key: 'title', options: IncidentDropdowns?.CauseTypes, keyName: "CauseType" },
            // { type: 1, label: "Approved By", keyName: 'totalCost' },
            { type: 2, label: "Approaved Date", keyName: 'ApprovedDate' },
            { type: 5, label: "Corrective Actions", keyName: 'CorrectiveActions' },
            { type: 5, label: "Approver Summary", keyName: 'ApproverSummary' },
        ],

    }
}

// src/Components/TableComponents/AuditTableColumns.js






export const causeCodeOptions = [
    {
        id: 1,
        "Code": "None"
    },
    {
        id: 2,
        "Code": "Other",
        // "Description": "Other"
    },
    {
        id: 3,
        "Code": "E51C",
        "Description": "Broken or bent axle between wheel seats",
        "Category": "Axles and Journal Bearings",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 4,
        "Code": "E51L",
        "Description": "Broken or bent axle between wheel seats (LOCOMOTIVE)",
        "Category": "Axles and Journal Bearings",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 5,
        "Code": "E52C",
        "Description": "Journal (plain) failure from overheating",
        "Category": "Axles and Journal Bearings",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 6,
        "Code": "E52L",
        "Description": "Journal (plain) failure from overheating (LOCOMOTIVE)",
        "Category": "Axles and Journal Bearings",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 7,
        "Code": "E53C",
        "Description": "Journal (roller bearing) failure from overheating",
        "Category": "Axles and Journal Bearings",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 8,
        "Code": "E53L",
        "Description": "Journal (roller bearing) failure from overheating- LOCOMOTIVE",
        "Category": "Axles and Journal Bearings",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 9,
        "Code": "E54C",
        "Description": "Journal fractured, new cold break",
        "Category": "Axles and Journal Bearings",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 10,
        "Code": "E54L",
        "Description": "Journal fractured, new cold break (LOCOMOTIVE)",
        "Category": "Axles and Journal Bearings",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 11,
        "Code": "E55C",
        "Description": "Journal fractured, cold break, previously overheated",
        "Category": "Axles and Journal Bearings",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 12,
        "Code": "E55L",
        "Description": "Journal fractured, cold break, previously overheated  (LOCOMOTIVE)",
        "Category": "Axles and Journal Bearings",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 13,
        "Code": "E59C",
        "Description": "Other axle and journal bearing defects (CAR) (Provide detailed description in narrative)",
        "Category": "Axles and Journal Bearings",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 14,
        "Code": "E59L",
        "Description": "Other axle and journal bearing defects (LOCOMOTIVE) (Provide detailed description in narrative)",
        "Category": "Axles and Journal Bearings",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 15,
        "Code": "E32L",
        "Description": "Couple drawhead broken or defective (locomotive)",
        "Category": "Coupler and Draft System",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 16,
        "Code": "E33C",
        "Description": "Coupler retainer pin/cross key missing",
        "Category": "Coupler and Draft System",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 17,
        "Code": "E34C",
        "Description": "Draft gear/mechanism broken or defective (including yoke)",
        "Category": "Coupler and Draft System",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 18,
        "Code": "E35L",
        "Description": "Coupler carrier broken or defective (LOCOMOTIVE)",
        "Category": "Coupler and Draft System",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 19,
        "Code": "E80C",
        "Description": "Box car plug door open",
        "Category": "Doors",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 20,
        "Code": "E81C",
        "Description": "Box car plug door, attachment defective",
        "Category": "Doors",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 21,
        "Code": "E82C",
        "Description": "Box car plug door, locking lever not in place",
        "Category": "Doors",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 22,
        "Code": "E83C",
        "Description": "Box car door, other than plug, open",
        "Category": "Doors",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 23,
        "Code": "E84C",
        "Description": "Box car door, other than plug, attachment defective",
        "Category": "Doors",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 24,
        "Code": "E85C",
        "Description": "Bottom outlet car door open",
        "Category": "Doors",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 25,
        "Code": "E86C",
        "Description": "Bottom outlet car door attachment defective",
        "Category": "Doors",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 26,
        "Code": "E89C",
        "Description": "Other car door defects (Provide detail description in  narrative)",
        "Category": "Doors",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 27,
        "Code": "E99C",
        "Description": "Other mechanical and electrical failures, (CAR) (Provide detailed description in narrative)",
        "Category": "General Mechanical Electrical Failures",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 28,
        "Code": "E99L",
        "Description": "Other mechanical and electrical failures, (LOCOMOTIVE) (Provide detailed description in narrative)",
        "Category": "General Mechanical Electrical Failures",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 29,
        "Code": "E70L",
        "Description": "Running gear failure (LOCOMOTIVE)",
        "Category": "Locomotives",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 30,
        "Code": "E71L",
        "Description": "Traction motor failure (LOCOMOTIVE)",
        "Category": "Locomotives",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 31,
        "Code": "E72L",
        "Description": "Crank case or air box explosion (LOCOMOTIVE)",
        "Category": "Locomotives",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 32,
        "Code": "E73L",
        "Description": "Oil or fuel fire (LOCOMOTIVE)",
        "Category": "Locomotives",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 33,
        "Code": "E74L",
        "Description": "Electrically caused fire (LOCOMOTIVE)",
        "Category": "Locomotives",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 34,
        "Code": "E75L",
        "Description": "Current collector system (LOCOMOTIVE)",
        "Category": "Locomotives",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 35,
        "Code": "E76L",
        "Description": "Remote control equipment inoperative (LOCOMOTIVE)",
        "Category": "Locomotives",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 36,
        "Code": "E77L",
        "Description": "Broken or defective swing hanger or spring plank  (LOCOMOTIVE)",
        "Category": "Locomotives",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 37,
        "Code": "E78L",
        "Description": "Pantograph defect (LOCOMOTIVE)",
        "Category": "Locomotives",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 38,
        "Code": "E79L",
        "Description": "Other locomotive defects (Provide detail description in narrative)",
        "Category": "Locomotives",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 39,
        "Code": "E7AL",
        "Description": "On-board computer - failure to respond (LOCOMOTIVE)",
        "Category": "Locomotives",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 40,
        "Code": "E7BL",
        "Description": "Third rail shoe or shoe beam (LOCOMOTIVE) ",
        "Category": "Locomotives",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 41,
        "Code": "E40C",
        "Description": "Side bearing clearance insufficient",
        "Category": "Truck Components",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 42,
        "Code": "E40L",
        "Description": "Side bearing clearance insufficient (LOCOMOTIVE)",
        "Category": "Truck Components",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 43,
        "Code": "E41C",
        "Description": "Side bearing clearance excessive",
        "Category": "Truck Components",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 44,
        "Code": "E41L",
        "Description": "Side bearing clearance excessive (LOCOMOTIVE)",
        "Category": "Truck Components",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 45,
        "Code": "E42C",
        "Description": "Side bearing(s) broken",
        "Category": "Truck Components",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 46,
        "Code": "E42L",
        "Description": "Side bearing(s) broken (LOCOMOTIVE)",
        "Category": "Truck Components",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 47,
        "Code": "E43C",
        "Description": "Side bearing(s) missing",
        "Category": "Truck Components",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 48,
        "Code": "E43L",
        "Description": "Side bearing(s) missing (LOCOMOTIVE)",
        "Category": "Truck Components",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 49,
        "Code": "E44C",
        "Description": "Truck bolster broken",
        "Category": "Truck Components",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 50,
        "Code": "E44L",
        "Description": "Truck bolster broken (LOCOMOTIVE)",
        "Category": "Truck Components",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 51,
        "Code": "E45C",
        "Description": "Side frame broken",
        "Category": "Truck Components",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 52,
        "Code": "E45L",
        "Description": "Side frame broken (LOCOMOTIVE)",
        "Category": "Truck Components",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 53,
        "Code": "E46C",
        "Description": "Truck bolster stiff, improper swiveling",
        "Category": "Truck Components",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 54,
        "Code": "E46L",
        "Description": "Truck bolster stiff, improper lateral or improper swiveling(LOCOMOTIVE)",
        "Category": "Truck Components",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 55,
        "Code": "E47C",
        "Description": "Defective snubbing  (including friction and hydraulic)",
        "Category": "Truck Components",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 56,
        "Code": "E47L",
        "Description": "Defective snubbing (LOCOMOTIVE)",
        "Category": "Truck Components",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 57,
        "Code": "E48C",
        "Description": "Broken, missing, or otherwise defective springs  (including incorrect repair and/or installation)",
        "Category": "Truck Components",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 58,
        "Code": "E48L",
        "Description": "Broken, missing, or otherwise defective springs (LOCOMOTIVE)",
        "Category": "Truck Components",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 59,
        "Code": "E49C",
        "Description": "Other truck component defects, including mismatched side frames  (CAR) (Provide detailed description in narrative)",
        "Category": "Truck Components",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 60,
        "Code": "E49L",
        "Description": "Other truck component defects, (LOCOMOTIVE) (Provide  detailed description in narrative)",
        "Category": "Truck Components",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 61,
        "Code": "E4AC",
        "Description": "Gib Clearance (lateral motion excessive)",
        "Category": "Truck Components",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 62,
        "Code": "E4BC",
        "Description": "Truck bolster stiff (failure to slew)",
        "Category": "Truck Components",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 63,
        "Code": "E4TC",
        "Description": "Truck hunting",
        "Category": "Truck Components",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 64,
        "Code": "E4TL",
        "Description": "Truck hunting (LOCOMOTIVE)",
        "Category": "Truck Components",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 65,
        "Code": "E60C",
        "Description": "Broken flange",
        "Category": "Wheels",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 66,
        "Code": "E60L",
        "Description": "Broken flange (LOCOMOTIVE)",
        "Category": "Wheels",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 67,
        "Code": "E61C",
        "Description": "Broken rim",
        "Category": "Wheels",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 68,
        "Code": "E61L",
        "Description": "Broken rim (LOCOMOTIVE)",
        "Category": "Wheels",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 69,
        "Code": "E62C",
        "Description": "Broken plate",
        "Category": "Wheels",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 70,
        "Code": "E62L",
        "Description": "Broken plate (LOCOMOTIVE)",
        "Category": "Wheels",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 71,
        "Code": "E63C",
        "Description": "Broken hub",
        "Category": "Wheels",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 72,
        "Code": "E63L",
        "Description": "Broken hub (LOCOMOTIVE)",
        "Category": "Wheels",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 73,
        "Code": "E64C",
        "Description": "Worn flange",
        "Category": "Wheels",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 74,
        "Code": "E64L",
        "Description": "Worn flange (LOCOMOTIVE)",
        "Category": "Wheels",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 75,
        "Code": "E65C",
        "Description": "Worn tread",
        "Category": "Wheels",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 76,
        "Code": "E65L",
        "Description": "Worn tread (LOCOMOTIVE)",
        "Category": "Wheels",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 77,
        "Code": "E66C",
        "Description": "Damaged flange or tread (flat)",
        "Category": "Wheels",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 78,
        "Code": "E66L",
        "Description": "Damaged flange or tread (flat) (LOCOMOTIVE)",
        "Category": "Wheels",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 79,
        "Code": "E67C",
        "Description": "Damaged flange or tread (build up)",
        "Category": "Wheels",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 80,
        "Code": "E67L",
        "Description": "Damaged flange or tread (build up) (LOCOMOTIVE)",
        "Category": "Wheels",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 81,
        "Code": "E68C",
        "Description": "Loose wheel",
        "Category": "Wheels",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 82,
        "Code": "E68L",
        "Description": "Loose wheel (LOCOMOTIVE)",
        "Category": "Wheels",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 83,
        "Code": "E69C",
        "Description": "Other wheel defects (CAR) (Provide detailed description in  narrative)",
        "Category": "Wheels",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 84,
        "Code": "E69L",
        "Description": "Other wheel defects (LOCOMOTIVE) (Provide detailed description in narrative)",
        "Category": "Wheels",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 85,
        "Code": "E6AC",
        "Description": "Thermal crack, flange or tread",
        "Category": "Wheels",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 86,
        "Code": "E6AL",
        "Description": "Thermal crack, flange or tread (LOCOMOTIVE)",
        "Category": "Wheels",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 87,
        "Code": "E20C",
        "Description": "Body bolster broken or defective",
        "Category": "  Body",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 88,
        "Code": "E20L",
        "Description": "Body bolster broken or defective (LOCOMOTIVE)",
        "Category": "  Body",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 89,
        "Code": "E21C",
        "Description": "Center sill broken or bent",
        "Category": "  Body",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 90,
        "Code": "E22L",
        "Description": "Draft sill broken or bent (LOCOMOTIVE)",
        "Category": "  Body",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 91,
        "Code": "E23C",
        "Description": "Center plate broken or defective",
        "Category": "  Body",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 92,
        "Code": "E23L",
        "Description": "Center plate broken or defective (LOCOMOTIVE)",
        "Category": "  Body",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 93,
        "Code": "E24C",
        "Description": "Center plate disengaged from truck (car off center)",
        "Category": "  Body",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 94,
        "Code": "E24L",
        "Description": "Center plate disengaged from truck unit/off center (LOCOMOTIVE)",
        "Category": "  Body",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 95,
        "Code": "E25C",
        "Description": "Center pin broken or missing",
        "Category": "  Body",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 96,
        "Code": "E25L",
        "Description": "Center pin broken or missing (LOCOMOTIVE)",
        "Category": "  Body",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 97,
        "Code": "E26C",
        "Description": "Center plate attachment defective",
        "Category": "  Body",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 98,
        "Code": "E26L",
        "Description": "Center plate attachment defective (LOCOMOTIVE)",
        "Category": "  Body",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 99,
        "Code": "E27C",
        "Description": "Side sill broken",
        "Category": "  Body",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 100,
        "Code": "E27L",
        "Description": "Side sill broken (LOCOMOTIVE)",
        "Category": "  Body",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 101,
        "Code": "E29C",
        "Description": "Other body defects, (CAR) (Provide detailed description in  narrative)",
        "Category": "  Body",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 102,
        "Code": "E29L",
        "Description": "Other body defects, (LOCOMOTIVE) (Provide detailed description in narrative)",
        "Category": "  Body",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 103,
        "Code": "E21L",
        "Description": "Center sill broken or bent (LOCOMOTIVE)",
        "Category": " Body",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 104,
        "Code": "E22C",
        "Description": "Draft sill broken or bent",
        "Category": " Body",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 105,
        "Code": "E00C",
        "Description": "Air hose uncoupled or burst",
        "Category": "Brake",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 106,
        "Code": "E00L",
        "Description": "Air hose uncoupled or burst (LOCOMOTIVE)",
        "Category": "Brake",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 107,
        "Code": "E01C",
        "Description": "Hydraulic hose uncoupled or burst",
        "Category": "Brake",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 108,
        "Code": "E01L",
        "Description": "Hydraulic hose uncoupled or burst (LOCOMOTIVE)",
        "Category": "Brake",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 109,
        "Code": "E02C",
        "Description": "Broken brake pipe or connections",
        "Category": "Brake",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 110,
        "Code": "E02L",
        "Description": "Broken brake pipe or connections (LOCOMOTIVE)",
        "Category": "Brake",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 111,
        "Code": "E03C",
        "Description": "Obstructed brake pipe (closed angle cock, ice, etc.)",
        "Category": "Brake",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 112,
        "Code": "E03L",
        "Description": "Obstructed brake pipe (closed angle cock, ice, etc.)  (LOCOMOTIVE)",
        "Category": "Brake",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 113,
        "Code": "E04C",
        "Description": "Other brake components damaged, worn, broken, or disconnected",
        "Category": "Brake",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 114,
        "Code": "E04L",
        "Description": "Other brake components damaged, worn, broken, or disconnected (LOCOMOTIVE)",
        "Category": "Brake",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 115,
        "Code": "E05C",
        "Description": "Brake valve malfunction (undesired emergency)",
        "Category": "Brake",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 116,
        "Code": "E05L",
        "Description": "Brake valve malfunction (undesired emergency) (LOCOMOTIVE)",
        "Category": "Brake",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 117,
        "Code": "E06C",
        "Description": "Brake valve malfunction (stuck brake, etc.)",
        "Category": "Brake",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 118,
        "Code": "E06L",
        "Description": "Brake valve malfunction (stuck brake, etc.) (LOCOMOTIVE)",
        "Category": "Brake",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 119,
        "Code": "E07C",
        "Description": "Rigging down or dragging",
        "Category": "Brake",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 120,
        "Code": "E07L",
        "Description": "Rigging down or dragging (LOCOMOTIVE)",
        "Category": "Brake",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 121,
        "Code": "E08C",
        "Description": "Hand brake (including gear) broken or defective",
        "Category": "Brake",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 122,
        "Code": "E08L",
        "Description": "Hand brake (including gear) broken or defective (LOCOMOTIVE)",
        "Category": "Brake",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 123,
        "Code": "E09C",
        "Description": "Other brake defects, cars (Provide detailed description in  narrative)",
        "Category": "Brake",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 124,
        "Code": "E09L",
        "Description": "Other brake defects, (Provide detailed description in narrative) (LOCOMOTIVE)",
        "Category": "Brake",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 125,
        "Code": "E0HC",
        "Description": "Hand brake linkage and/or connections broken or defective",
        "Category": "Brake",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 126,
        "Code": "E0HL",
        "Description": "Hand brake linkage/Connections broken/defective (LOCOMOTIVE)",
        "Category": "Brake",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 127,
        "Code": "E10L",
        "Description": "Computer controlled brake communication failure (LOCOMOTIVE)",
        "Category": "Brake",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 128,
        "Code": "E30C",
        "Description": "Knuckle broken or defective",
        "Category": "Coupler and Draft System",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 129,
        "Code": "E30L",
        "Description": "Knuckle broken or defective",
        "Category": "Coupler and Draft System",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 130,
        "Code": "E31C",
        "Description": "Coupler mismatch, high/low",
        "Category": "Coupler and Draft System",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 131,
        "Code": "E31L",
        "Description": "Coupler mismatch, high/low (LOCOMOTIVE)",
        "Category": "Coupler and Draft System",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 132,
        "Code": "E32C",
        "Description": "Couple drawhead broken or defective",
        "Category": "Coupler and Draft System",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 133,
        "Code": "E33L",
        "Description": "Coupler retainer pin/cross key missing (LOCOMOTIVE)",
        "Category": "Coupler and Draft System",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 134,
        "Code": "E34L",
        "Description": "Draft gear/mechanism broken/defective (including yoke) (LOCOMOTIVE)",
        "Category": "Coupler and Draft System",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 135,
        "Code": "E35C",
        "Description": "Coupler carrier broken or defective",
        "Category": "Coupler and Draft System",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 136,
        "Code": "E36C",
        "Description": "Coupler shank broken or defective (includes defective alignment control)",
        "Category": "Coupler and Draft System",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 137,
        "Code": "E36L",
        "Description": "Coupler shank broken or defective (includes defective includes defective alignment control) (LOCOMOTIVE)",
        "Category": "Coupler and Draft System",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 138,
        "Code": "E37C",
        "Description": "Failure of articulated connectors",
        "Category": "Coupler and Draft System",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 139,
        "Code": "E37L",
        "Description": "Failure of articulated connectors (LOCOMOTIVE) ",
        "Category": "Coupler and Draft System",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 140,
        "Code": "E39C",
        "Description": "Other coupler and draft system defects, (CAR) (Provide detailed description in narrative)",
        "Category": "Coupler and Draft System",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 141,
        "Code": "E39L",
        "Description": "Other coupler and draft system defects, (LOCOMOTIVE)  (Provide detailed description in narrative)",
        "Category": "Coupler and Draft System",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 142,
        "Code": "E11C",
        "Description": "Broken or defective tiedown equipment",
        "Category": "Trailer Or Container On Flatcar",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 143,
        "Code": "E12C",
        "Description": "Broken or defective container",
        "Category": "Trailer Or Container On Flatcar",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 144,
        "Code": "E13C",
        "Description": "Broken or defective trailer",
        "Category": "Trailer Or Container On Flatcar",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 145,
        "Code": "E19C",
        "Description": "Other trailer or container on flat car defects (Provide detailed description in narrative)",
        "Category": "Trailer Or Container On Flatcar",
        "Title": "Mechanical and Electrical Failures"
    },
    {
        id: 146,
        "Code": "M101",
        "Description": "Snow, ice, mud, gravel, coal, sand, etc. on track",
        "Category": "Environment Conditions",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 147,
        "Code": "M102",
        "Description": "Extreme environmental condition ‑ TORNADO",
        "Category": "Environment Conditions",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 148,
        "Code": "M103",
        "Description": "Extreme environmental condition ‑ FLOOD",
        "Category": "Environment Conditions",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 149,
        "Code": "M104",
        "Description": "Extreme environmental condition ‑ DENSE FOG",
        "Category": "Environment Conditions",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 150,
        "Code": "M105",
        "Description": "Extreme environmental condition ‑ EXTREME WIND VELOCITY",
        "Category": "Environment Conditions",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 151,
        "Code": "M199",
        "Description": "Other extreme environmental conditions (Provide detailed description in narrative)",
        "Category": "Environment Conditions",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 152,
        "Code": "M201",
        "Description": "Load shifted",
        "Category": "Loading Procedures",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 153,
        "Code": "M202",
        "Description": "Load fell from car",
        "Category": "Loading Procedures",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 154,
        "Code": "M203",
        "Description": "Overloaded car",
        "Category": "Loading Procedures",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 155,
        "Code": "M204",
        "Description": "Improperly loaded car",
        "Category": "Loading Procedures",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 156,
        "Code": "M206",
        "Description": "Trailer or container tiedown equipment improperly applied",
        "Category": "Loading Procedures",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 157,
        "Code": "M207",
        "Description": "Overloaded container/trailer on flat car",
        "Category": "Loading Procedures",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 158,
        "Code": "M208",
        "Description": "Improperly loaded container/trailer on flat car",
        "Category": "Loading Procedures",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 159,
        "Code": "M299",
        "Description": "Miscellaneous loading procedures (Provide detailed description in narrative)",
        "Category": "Loading Procedures",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 160,
        "Code": "M301",
        "Description": "Highway user impairment because of drug or alcohol usage  (as determined by local authorities, e.g., police)",
        "Category": "Loading Procedures",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 161,
        "Code": "M302",
        "Description": "Highway user inattentiveness",
        "Category": "Loading Procedures",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 162,
        "Code": "M303",
        "Description": "Highway user misjudgment under normal weather and traffic conditions",
        "Category": "Loading Procedures",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 163,
        "Code": "M304",
        "Description": "Highway user cited for violation of highway-rail grade crossing traffic laws",
        "Category": "Loading Procedures",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 164,
        "Code": "M305",
        "Description": "Highway user unawareness due to environmental factors  (angle of sun, etc.)",
        "Category": "Loading Procedures",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 165,
        "Code": "M306",
        "Description": "Highway user inability to stop due to extreme weather conditions (dense fog, ice or snow packed road, etc.)",
        "Category": "Loading Procedures",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 166,
        "Code": "M307",
        "Description": "Malfunction, improper operation of train activated warning devices",
        "Category": "Loading Procedures",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 167,
        "Code": "M308  ",
        "Description": "Highway user deliberately disregarded crossing warning devices",
        "Category": "Loading Procedures",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 168,
        "Code": "M401",
        "Description": "Emergency brake application to avoid accident",
        "Category": "Loading Procedures",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 169,
        "Code": "M402",
        "Description": "Object or equipment on or fouling track (motor vehicle - other than highway-rail crossing)",
        "Category": "Loading Procedures",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 170,
        "Code": "M403",
        "Description": "Object or equipment on or fouling track (livestock)",
        "Category": "Loading Procedures",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 171,
        "Code": "M404",
        "Description": "Object or equipment on or fouling track - other than above (for  vandalism, see code M503)",
        "Category": "Loading Procedures",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 172,
        "Code": "M405",
        "Description": "Interaction of lateral/vertical forces (includes harmonic rock off)",
        "Category": "Loading Procedures",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 173,
        "Code": "M406",
        "Description": "Fire, other than vandalism, involving on‑track equipment",
        "Category": "Loading Procedures",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 174,
        "Code": "M407",
        "Description": "Automatic hump retarder failed to sufficiently slow car due to foreign material on wheels of car being humped",
        "Category": "Loading Procedures",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 175,
        "Code": "M408",
        "Description": "Yard skate slid and failed to stop cars",
        "Category": "Loading Procedures",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 176,
        "Code": "M409",
        "Description": "Objects such as lading chains or straps fouling switches",
        "Category": "Loading Procedures",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 177,
        "Code": "M410",
        "Description": "Objects such as lading chains or straps fouling wheels",
        "Category": "Loading Procedures",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 178,
        "Code": "M411",
        "Description": "Passed couplers (automated classification yard)",
        "Category": "Loading Procedures",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 179,
        "Code": "M501",
        "Description": "Interference (other than vandalism) with railroad operations by nonrailroad employee",
        "Category": "Loading Procedures",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 180,
        "Code": "M502",
        "Description": "Vandalism of on-track equipment, e.g., brakes released",
        "Category": "Loading Procedures",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 181,
        "Code": "M503",
        "Description": "Vandalism of track or track appliances, e.g., objects  placed on track, switch thrown, etc.",
        "Category": "Loading Procedures",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 182,
        "Code": "M504",
        "Description": "Failure by non railroad employee, e.g., industry employee, to control speed of car using hand brake",
        "Category": "Loading Procedures",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 183,
        "Code": "M505",
        "Description": "Cause under active investigation by reporting railroad  (Amended report will be forwarded when reporting railroad’s active investigation has been completed.)",
        "Category": "Loading Procedures",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 184,
        "Code": "M506",
        "Description": "Track damage caused by non-railroad interference with track structure",
        "Category": "Loading Procedures",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 185,
        "Code": "M507",
        "Description": "Investigation complete, cause could not be determined (When using this code, the narrative must include the reason(s) why the cause of the accident/incident could not be determined.)",
        "Category": "Loading Procedures",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 186,
        "Code": "M599",
        "Description": "Other miscellaneous causes (Provide detailed description in narrative)",
        "Category": "Loading Procedures",
        "Title": "Miscellaneous Causes Not Otherwise Listed"
    },
    {
        id: 187,
        "Code": "T101",
        "Description": "Cross level of track irregular (at joints)",
        "Category": " Track Geometry",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 188,
        "Code": "T109",
        "Description": "Track alignment irregular (buckled/sunkink)",
        "Category": " Track Geometry",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 189,
        "Code": "T301",
        "Description": "Derail, defective",
        "Category": "Frogs, Switches and Track Appliances",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 190,
        "Code": "T302",
        "Description": "Expansion joint failed or malfunctioned",
        "Category": "Frogs, Switches and Track Appliances",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 191,
        "Code": "T303",
        "Description": "Guard rail loose/broken or mislocated",
        "Category": "Frogs, Switches and Track Appliances",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 192,
        "Code": "T304",
        "Description": "Railroad crossing frog, worn or broken",
        "Category": "Frogs, Switches and Track Appliances",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 193,
        "Code": "T305",
        "Description": "Retarder worn, broken, or malfunctioning",
        "Category": "Frogs, Switches and Track Appliances",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 194,
        "Code": "T306",
        "Description": "Retarder yard skate defective",
        "Category": "Frogs, Switches and Track Appliances",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 195,
        "Code": "T307",
        "Description": "Spring/power switch mechanism malfunction",
        "Category": "Frogs, Switches and Track Appliances",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 196,
        "Code": "T308",
        "Description": "Stock rail worn, broken or disconnected",
        "Category": "Frogs, Switches and Track Appliances",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 197,
        "Code": "T309",
        "Description": "Switch (hand operated) stand mechanism broken, loose, or worn",
        "Category": "Frogs, Switches and Track Appliances",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 198,
        "Code": "T310",
        "Description": "Switch connecting or operating rod is broken or defective",
        "Category": "Frogs, Switches and Track Appliances",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 199,
        "Code": "T311",
        "Description": "Switch damaged or out of adjustment",
        "Category": "Frogs, Switches and Track Appliances",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 200,
        "Code": "T312",
        "Description": "Switch lug/crank broken",
        "Category": "Frogs, Switches and Track Appliances",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 201,
        "Code": "T313",
        "Description": "Switch out of adjustment because of insufficient rail anchoring",
        "Category": "Frogs, Switches and Track Appliances",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 202,
        "Code": "T314",
        "Description": "Switch point worn or broken",
        "Category": "Frogs, Switches and Track Appliances",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 203,
        "Code": "T315",
        "Description": "Switch rod worn, bent, broken, or disconnected",
        "Category": "Frogs, Switches and Track Appliances",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 204,
        "Code": "T316",
        "Description": "Turnout frog (rigid) worn, or broken",
        "Category": "Frogs, Switches and Track Appliances",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 205,
        "Code": "T317",
        "Description": "Turnout frog (self guarded), worn or broken",
        "Category": "Frogs, Switches and Track Appliances",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 206,
        "Code": "T318",
        "Description": "Turnout frog (spring) worn, or broken",
        "Category": "Frogs, Switches and Track Appliances",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 207,
        "Code": "T319",
        "Description": "Switch point gapped (between switch point and stock rail)",
        "Category": "Frogs, Switches and Track Appliances",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 208,
        "Code": "T399",
        "Description": "Other frog, switch and track appliance defects (Provide detail",
        "Category": "Frogs, Switches and Track Appliances",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 209,
        "Code": "T401",
        "Description": "Bridge misalignment or failure",
        "Category": "Other Way and Structure",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 210,
        "Code": "T402",
        "Description": "Flangeway clogged",
        "Category": "Other Way and Structure",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 211,
        "Code": "T403",
        "Description": "Engineering design or construction",
        "Category": "Other Way and Structure",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 212,
        "Code": "T404",
        "Description": "Catenary system defect",
        "Category": "Other Way and Structure",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 213,
        "Code": "T499",
        "Description": "Other way and structure defect (Provide detailed description in narrative)",
        "Category": "Other Way and Structure",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 214,
        "Code": "T201",
        "Description": "Broken Rail - Bolt hole crack or break",
        "Category": "Rail, Joint Bar and Rail Anchoring",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 215,
        "Code": "T202",
        "Description": ".Broken Rail - Base",
        "Category": "Rail, Joint Bar and Rail Anchoring",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 216,
        "Code": "T203",
        "Description": "Broken Rail - Weld (plant)",
        "Category": "Rail, Joint Bar and Rail Anchoring",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 217,
        "Code": "T204",
        "Description": "Broken Rail - Weld (field)",
        "Category": "Rail, Joint Bar and Rail Anchoring",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 218,
        "Code": "T205",
        "Description": "Defective or missing crossties (use code T110 if results in wide gage)",
        "Category": "Rail, Joint Bar and Rail Anchoring",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 219,
        "Code": "T206",
        "Description": "Defective spikes or missing spikes or other rail fasteners (use code T111 if results in wide gage)",
        "Category": "Rail, Joint Bar and Rail Anchoring",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 220,
        "Code": "T207",
        "Description": "Broken Rail - Detail fracture from shelling or head check",
        "Category": "Rail, Joint Bar and Rail Anchoring",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 221,
        "Code": "T208",
        "Description": "Broken Rail - Engine burn fracture",
        "Category": "Rail, Joint Bar and Rail Anchoring",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 222,
        "Code": "T210",
        "Description": "Broken Rail - Head and web separation (outside joint bar limits)",
        "Category": "Rail, Joint Bar and Rail Anchoring",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 223,
        "Code": "T211",
        "Description": "Broken Rail - Head and web separation (within joint bar limits)",
        "Category": "Rail, Joint Bar and Rail Anchoring",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 224,
        "Code": "T212",
        "Description": "Broken Rail - Horizontal split head",
        "Category": "Rail, Joint Bar and Rail Anchoring",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 225,
        "Code": "T213",
        "Description": "Joint bar broken (compromise)",
        "Category": "Rail, Joint Bar and Rail Anchoring",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 226,
        "Code": "T214",
        "Description": "Joint bar broken (insulated)",
        "Category": "Rail, Joint Bar and Rail Anchoring",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 227,
        "Code": "T215",
        "Description": "Joint bar broken (noninsulated)",
        "Category": "Rail, Joint Bar and Rail Anchoring",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 228,
        "Code": "T216",
        "Description": "Joint bolts, broken, or missing",
        "Category": "Rail, Joint Bar and Rail Anchoring",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 229,
        "Code": "T217",
        "Description": "Mismatched rail‑head contour",
        "Category": "Rail, Joint Bar and Rail Anchoring",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 230,
        "Code": "T218",
        "Description": "Broken Rail - Piped rail",
        "Category": "Rail, Joint Bar and Rail Anchoring",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 231,
        "Code": "T219",
        "Description": "Rail defect with joint bar repair",
        "Category": "Rail, Joint Bar and Rail Anchoring",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 232,
        "Code": "T220",
        "Description": "Broken Rail - Transverse/compound fissure ",
        "Category": "Rail, Joint Bar and Rail Anchoring",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 233,
        "Code": "T221",
        "Description": "Broken Rail - Vertical split head ",
        "Category": "Rail, Joint Bar and Rail Anchoring",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 234,
        "Code": "T222",
        "Description": "Worn rail",
        "Category": "Rail, Joint Bar and Rail Anchoring",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 235,
        "Code": "T223",
        "Description": "Rail Condition - Dry rail, freshly ground rail.",
        "Category": "Rail, Joint Bar and Rail Anchoring",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 236,
        "Code": "T299",
        "Description": "Other rail and joint bar defects (Provide detailed description in narrative) ",
        "Category": "Rail, Joint Bar and Rail Anchoring",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 237,
        "Code": "T001",
        "Description": "Roadbed settled or soft",
        "Category": "Roadbed",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 238,
        "Code": "T002",
        "Description": "Washout/rain/slide/flood/snow/ice damage to track",
        "Category": "Roadbed",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 239,
        "Code": "T099",
        "Description": "Other roadbed defects (Provide detailed description in narrative)",
        "Category": "Roadbed",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 240,
        "Code": "T102",
        "Description": "Cross level of track irregular (not at joints)",
        "Category": "Track Geometry",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 241,
        "Code": "T103",
        "Description": "Deviation from uniform top of rail profile",
        "Category": "Track Geometry",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 242,
        "Code": "T104",
        "Description": "Disturbed ballast section",
        "Category": "Track Geometry",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 243,
        "Code": "T105",
        "Description": "Insufficient ballast section",
        "Category": "Track Geometry",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 244,
        "Code": "T106",
        "Description": "Superelevation improper, excessive, or insufficient",
        "Category": "Track Geometry",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 245,
        "Code": "T107",
        "Description": "Superelevation runoff improper",
        "Category": "Track Geometry",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 246,
        "Code": "T108",
        "Description": "Track alignment irregular (other than buckled/sunkink)",
        "Category": "Track Geometry",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 247,
        "Code": "T110",
        "Description": "Wide gage (due to defective or missing crossties)",
        "Category": "Track Geometry",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 248,
        "Code": "T111",
        "Description": "Wide gage (due to defective or missing spikes or other rail fasteners)",
        "Category": "Track Geometry",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 249,
        "Code": "T112",
        "Description": "Wide gage (due to loose, broken, or defective gage rods)",
        "Category": "Track Geometry",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 250,
        "Code": "T113",
        "Description": "Wide gage (due to worn rails)",
        "Category": "Track Geometry",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 251,
        "Code": "T199",
        "Description": "Other track geometry defects (Provide detailed description in narrative)",
        "Category": "Track Geometry",
        "Title": "Rack, Roadbed and Structures"
    },
    {
        id: 252,
        "Code": "S001",
        "Description": "Automatic cab signal displayed false proceed",
        "Category": "Signal and Communication",
        "Title": "Signal and Communication"
    },
    {
        id: 253,
        "Code": "S002",
        "Description": "Automatic cab signal inoperative",
        "Category": "Signal and Communication",
        "Title": "Signal and Communication"
    },
    {
        id: 254,
        "Code": "S003",
        "Description": "Automatic train control system inoperative",
        "Category": "Signal and Communication",
        "Title": "Signal and Communication"
    },
    {
        id: 255,
        "Code": "S004",
        "Description": "Automatic train‑stop device inoperative",
        "Category": "Signal and Communication",
        "Title": "Signal and Communication"
    },
    {
        id: 256,
        "Code": "S005",
        "Description": "Block signal displayed false proceed",
        "Category": "Signal and Communication",
        "Title": "Signal and Communication"
    },
    {
        id: 257,
        "Code": "S006",
        "Description": "Classification yard automatic control system switch failure",
        "Category": "Signal and Communication",
        "Title": "Signal and Communication"
    },
    {
        id: 258,
        "Code": "S007",
        "Description": "Classification yard automatic control system retarder failure",
        "Category": "Signal and Communication",
        "Title": "Signal and Communication"
    },
    {
        id: 259,
        "Code": "S008",
        "Description": "Fixed signal improperly displayed (defective)",
        "Category": "Signal and Communication",
        "Title": "Signal and Communication"
    },
    {
        id: 260,
        "Code": "S009",
        "Description": "Interlocking signal displayed false proceed",
        "Category": "Signal and Communication",
        "Title": "Signal and Communication"
    },
    {
        id: 261,
        "Code": "S010",
        "Description": "Power device interlocking failure",
        "Category": "Signal and Communication",
        "Title": "Signal and Communication"
    },
    {
        id: 262,
        "Code": "S011",
        "Description": "Power switch failure",
        "Category": "Signal and Communication",
        "Title": "Signal and Communication"
    },
    {
        id: 263,
        "Code": "S012",
        "Description": "Radio communication equipment failure",
        "Category": "Signal and Communication",
        "Title": "Signal and Communication"
    },
    {
        id: 264,
        "Code": "S013",
        "Description": "Other communication equipment failure",
        "Category": "Signal and Communication",
        "Title": "Signal and Communication"
    },
    {
        id: 265,
        "Code": "S014",
        "Description": "Computer system design error (vendor)",
        "Category": "Signal and Communication",
        "Title": "Signal and Communication"
    },
    {
        id: 266,
        "Code": "S015",
        "Description": "Computer system configuration/management error (vendor)",
        "Category": "Signal and Communication",
        "Title": "Signal and Communication"
    },
    {
        id: 267,
        "Code": "S016",
        "Description": "Classification yard automatic control system - Inadequate or insufficient control  (e.g., automatic cycling, other software / programming deficiencies, etc.)",
        "Category": "Signal and Communication",
        "Title": "Signal and Communication"
    },
    {
        id: 268,
        "Code": "S099",
        "Description": "Other signal failures (Provide detailed description in narrative)",
        "Category": "Signal and Communication",
        "Title": "Signal and Communication"
    },
    {
        id: 269,
        "Code": "S101",
        "Description": "Remote control transmitter defective",
        "Category": "Signal and Communication",
        "Title": "Signal and Communication"
    },
    {
        id: 270,
        "Code": "S102",
        "Description": "Remote control transmitter, loss of communication.  ",
        "Category": "Signal and Communication",
        "Title": "Signal and Communication"
    },
    {
        id: 271,
        "Code": "S103",
        "Description": "Radio controlled switch communication failure",
        "Category": "Signal and Communication",
        "Title": "Signal and Communication"
    },
    {
        id: 272,
        "Code": "S104",
        "Description": "Radio controlled switch not locked effectively",
        "Category": "Signal and Communication",
        "Title": "Signal and Communication"
    },
    {
        id: 273,
        "Code": "H008",
        "Description": "Improper operation of train line air connections  (bottling the air)",
        "Category": "Brakes, Use of",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 274,
        "Code": "H017",
        "Description": "Failure to properly secure engine(s) (railroad employee)",
        "Category": "Brakes, Use of",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 275,
        "Code": "H018",
        "Description": "Failure to properly secure hand brake on car(s) (railroad  employee)",
        "Category": "Brakes, Use of",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 276,
        "Code": "H019",
        "Description": "Failure to release hand brakes on car(s) (railroad employee)",
        "Category": "Brakes, Use of",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 277,
        "Code": "H020",
        "Description": "Failure to apply sufficient number of hand brakes on car(s) (railroad employee)",
        "Category": "Brakes, Use of",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 278,
        "Code": "H021",
        "Description": "Failure to apply hand brakes on car(s) (railroad employee)",
        "Category": "Brakes, Use of",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 279,
        "Code": "H022",
        "Description": "Failure to properly secure engine(s) or car(s) (non railroad employee)",
        "Category": "Brakes, Use of",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 280,
        "Code": "H025",
        "Description": "Failure to control speed of car using hand brake (railroad employee)",
        "Category": "Brakes, Use of",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 281,
        "Code": "H099",
        "Description": "Use of brakes, other (Provide detailed description in narrative)",
        "Category": "Brakes, Use of",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 282,
        "Code": "H821",
        "Description": "Automatic cab signal, failure to comply",
        "Category": "Cab Signals",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 283,
        "Code": "H822",
        "Description": "Automatic cab signal cut out",
        "Category": "Cab Signals",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 284,
        "Code": "H823",
        "Description": "Automatic train‑stop device cut out",
        "Category": "Cab Signals",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 285,
        "Code": "H824",
        "Description": "Automatic train control device cut out",
        "Category": "Cab Signals",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 286,
        "Code": "H899",
        "Description": "Other causes relating to cab signals (provide detailed description in narrative)",
        "Category": "Cab Signals",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 287,
        "Code": "H101",
        "Description": "Impairment of efficiency or judgment because of drugs or alcohol",
        "Category": "Employee Physical Condition",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 288,
        "Code": "H102",
        "Description": "Incapacitation due to injury or illness",
        "Category": "Employee Physical Condition",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 289,
        "Code": "H103",
        "Description": "Employee restricted in work or motion",
        "Category": "Employee Physical Condition",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 290,
        "Code": "H104",
        "Description": "Employee asleep",
        "Category": "Employee Physical Condition",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 291,
        "Code": "H199",
        "Description": "Employee physical condition, other (Provide detailed description in narrative)",
        "Category": "Employee Physical Condition",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 292,
        "Code": "H201",
        "Description": "Blue Signal, absence of",
        "Category": "Flagging, Fixed, Hand and Radio Signals",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 293,
        "Code": "H202",
        "Description": "Blue Signal, imperfectly displayed",
        "Category": "Flagging, Fixed, Hand and Radio Signals",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 294,
        "Code": "H205",
        "Description": "Flagging, improper or failure to flag",
        "Category": "Flagging, Fixed, Hand and Radio Signals",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 295,
        "Code": "H206",
        "Description": "Flagging signal, failure to comply",
        "Category": "Flagging, Fixed, Hand and Radio Signals",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 296,
        "Code": "H207",
        "Description": "Hand signal, failure to comply",
        "Category": "Flagging, Fixed, Hand and Radio Signals",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 297,
        "Code": "H208",
        "Description": "Hand signal improper",
        "Category": "Flagging, Fixed, Hand and Radio Signals",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 298,
        "Code": "H209",
        "Description": "Hand signal, failure to give/receive",
        "Category": "Flagging, Fixed, Hand and Radio Signals",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 299,
        "Code": "H210",
        "Description": "Radio communication, failure to comply",
        "Category": "Flagging, Fixed, Hand and Radio Signals",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 300,
        "Code": "H211",
        "Description": "Radio communication, improper",
        "Category": "Flagging, Fixed, Hand and Radio Signals",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 301,
        "Code": "H212",
        "Description": "Radio communication, failure to give/receive",
        "Category": "Flagging, Fixed, Hand and Radio Signals",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 302,
        "Code": "H217",
        "Description": "Failure to observe hand signals given during a wayside inspection of  moving train",
        "Category": "Flagging, Fixed, Hand and Radio Signals",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 303,
        "Code": "H218",
        "Description": "Failure to comply with failed equipment detector warning or with applicable train inspection rules.",
        "Category": "Flagging, Fixed, Hand and Radio Signals",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 304,
        "Code": "H219",
        "Description": "Fixed signal (other than automatic block or interlocking signal), improperly displayed.",
        "Category": "Flagging, Fixed, Hand and Radio Signals",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 305,
        "Code": "H220",
        "Description": "Fixed signal (other than automatic block or interlocking signal), failure to comply.",
        "Category": "Flagging, Fixed, Hand and Radio Signals",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 306,
        "Code": "H221",
        "Description": "Automatic block or interlocking signal displaying a stop indication - failure to comply.*",
        "Category": "Flagging, Fixed, Hand and Radio Signals",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 307,
        "Code": "H222",
        "Description": "Automatic block or interlocking signal displaying other than a stop indication - failure to comply.*",
        "Category": "Flagging, Fixed, Hand and Radio Signals",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 308,
        "Code": "H299",
        "Description": "Other signal causes (Provide detailed description in narrative)",
        "Category": "Flagging, Fixed, Hand and Radio Signals",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 309,
        "Code": "H301",
        "Description": "Car(s) shoved out and left out of clear",
        "Category": "General Switching Rules",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 310,
        "Code": "H302",
        "Description": "Cars left foul",
        "Category": "General Switching Rules",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 311,
        "Code": "H303",
        "Description": "Derail, failure to apply or remove",
        "Category": "General Switching Rules",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 312,
        "Code": "H304",
        "Description": "Hazardous materials regulations, failure to comply",
        "Category": "General Switching Rules",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 313,
        "Code": "H305",
        "Description": "Instruction to train/yard crew improper",
        "Category": "General Switching Rules",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 314,
        "Code": "H306",
        "Description": "Shoving movement, absence of man on or at leading end of movement",
        "Category": "General Switching Rules",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 315,
        "Code": "H307",
        "Description": "Shoving movement, man on or at leading end of movement, failure to control",
        "Category": "General Switching Rules",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 316,
        "Code": "H308",
        "Description": "Skate, failure to remove or place",
        "Category": "General Switching Rules",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 317,
        "Code": "H309",
        "Description": "Failure to stretch cars before shoving",
        "Category": "General Switching Rules",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 318,
        "Code": "H310",
        "Description": "Failure to couple",
        "Category": "General Switching Rules",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 319,
        "Code": "H311",
        "Description": "Moving cars while loading ramp/hose/chute/cables/bridge plate, etc., not in proper position",
        "Category": "General Switching Rules",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 320,
        "Code": "H312",
        "Description": "Passed couplers (other than automated classification yard)",
        "Category": "General Switching Rules",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 321,
        "Code": "H313",
        "Description": "Retarder, improper manual operation",
        "Category": "General Switching Rules",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 322,
        "Code": "H314",
        "Description": "Retarder yard skate improperly applied",
        "Category": "General Switching Rules",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 323,
        "Code": "H315",
        "Description": "Portable derail, improperly applied",
        "Category": "General Switching Rules",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 324,
        "Code": "H316",
        "Description": "Manual intervention of classification yard automatic control system modes by operator",
        "Category": "General Switching Rules",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 325,
        "Code": "H317",
        "Description": "Humping or cutting off in motion equipment susceptible to damage, or to cause damage to other equipment",
        "Category": "General Switching Rules",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 326,
        "Code": "H318",
        "Description": "Kicking or dropping cars, inadequate precautions",
        "Category": "General Switching Rules",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 327,
        "Code": "H399",
        "Description": "Other general switching rules (Provide detailed  description in narrative)",
        "Category": "General Switching Rules",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 328,
        "Code": "M399",
        "Description": "Other causes (Provide detailed description in narrative)",
        "Category": "Loading Procedures",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 329,
        "Code": "H401",
        "Description": "Failure to stop train in clear",
        "Category": "Main Track Authority",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 330,
        "Code": "H402",
        "Description": "Motor car or on‑track equipment rules, failure to comply",
        "Category": "Main Track Authority",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 331,
        "Code": "H403",
        "Description": "Movement of engine(s) or car(s) without authority  (railroad employee)",
        "Category": "Main Track Authority",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 332,
        "Code": "H404",
        "Description": "Train order, track warrant, track bulletin, or timetable authority, failure to comply",
        "Category": "Main Track Authority",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 333,
        "Code": "H405",
        "Description": "Train orders, track warrants, direct traffic control, track bulletins, radio, error in preparation,  transmission or delivery",
        "Category": "Main Track Authority",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 334,
        "Code": "H406",
        "Description": "Train orders, track warrants, direct traffic control, track bulletins, written, error in preparation, transmission or delivery",
        "Category": "Main Track Authority",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 335,
        "Code": "H499",
        "Description": "Other main track authority causes (Provide detailed description in narrative) ",
        "Category": "Main Track Authority",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 336,
        "Code": "H991",
        "Description": "Tampering with safety/protective device(s)",
        "Category": "Miscellaneous",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 337,
        "Code": "H992",
        "Description": "Operation of locomotive by uncertified/unqualified person",
        "Category": "Miscellaneous",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 338,
        "Code": "H993",
        "Description": "Human Factor - track",
        "Category": "Miscellaneous",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 339,
        "Code": "H994",
        "Description": "Human Factor - Signal installation or maintenance error (field)",
        "Category": "Miscellaneous",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 340,
        "Code": "H995",
        "Description": "Human Factor - motive power and equipment",
        "Category": "Miscellaneous",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 341,
        "Code": "H996",
        "Description": "Oversized loads or Excess Height/Width cars, mis-routed or switched.",
        "Category": "Miscellaneous",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 342,
        "Code": "H997",
        "Description": "Motor car or other on-track equipment rules (other than main track authority) - Failure to Comply.",
        "Category": "Miscellaneous",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 343,
        "Code": "H999",
        "Description": "Other train operation/human factors (Provide detailed description in narrative)",
        "Category": "Miscellaneous",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 344,
        "Code": "H99A",
        "Description": "Human Factor - Signal - Train Control - Installation or maintenance error (shop).",
        "Category": "Miscellaneous",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 345,
        "Code": "H99B",
        "Description": "Human Factor - Signal - Train Control - Operator Input On-board computer incorrect data entry.",
        "Category": "Miscellaneous",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 346,
        "Code": "H99C",
        "Description": "Human Factor - Signal - Train Control - Operator Input On-board computer incorrect data provided",
        "Category": "Miscellaneous",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 347,
        "Code": "H99D",
        "Description": "Computer system design error (non vendor)",
        "Category": "Miscellaneous",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 348,
        "Code": "H99E",
        "Description": "Computer system configuration/management error (non vendor)",
        "Category": "Miscellaneous",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 349,
        "Code": "H601",
        "Description": "Coupling speed excessive",
        "Category": "Speed",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 350,
        "Code": "H602",
        "Description": "Switching movement, excessive speed",
        "Category": "Speed",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 351,
        "Code": "H603",
        "Description": "Train on main track inside yard limits, excessive speed",
        "Category": "Speed",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 352,
        "Code": "H604",
        "Description": "Train outside yard limits, in block signal or interlocking territory, excessive speed",
        "Category": "Speed",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 353,
        "Code": "H605",
        "Description": "Failure to comply with restricted speed in connection with the restrictive indication of a block or interlocking signal.",
        "Category": "Speed",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 354,
        "Code": "H606",
        "Description": "Train outside yard limits in non block territory, excessive speed",
        "Category": "Speed",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 355,
        "Code": "H607",
        "Description": "Failure to comply with restricted speed or its equivalent not in connection with a block or interlocking signal.",
        "Category": "Speed",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 356,
        "Code": "H699",
        "Description": "Speed, other (Provide detailed description in narrative)",
        "Category": "Speed",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 357,
        "Code": "H701",
        "Description": "Spring Switch not cleared before reversing",
        "Category": "Switches, Use of",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 358,
        "Code": "H702",
        "Description": "Switch improperly lined",
        "Category": "Switches, Use of",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 359,
        "Code": "H703",
        "Description": "Switch not latched or locked",
        "Category": "Switches, Use of",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 360,
        "Code": "H704",
        "Description": "Switch previously run through",
        "Category": "Switches, Use of",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 361,
        "Code": "H705",
        "Description": "Moveable point switch frog improperly lined",
        "Category": "Switches, Use of",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 362,
        "Code": "H706",
        "Description": "Switch improperly lined, radio controlled",
        "Category": "Switches, Use of",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 363,
        "Code": "H707",
        "Description": "Radio controlled switch not locked effectively",
        "Category": "Switches, Use of",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 364,
        "Code": "H799",
        "Description": "Use of switches, other (Provide detailed description in narrative)",
        "Category": "Switches, Use of",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 365,
        "Code": "H501",
        "Description": "Improper train make‑up at initial terminal",
        "Category": "Train Handling / Train Make-Up",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 366,
        "Code": "H502",
        "Description": "Improper placement of cars in train between terminals",
        "Category": "Train Handling / Train Make-Up",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 367,
        "Code": "H503",
        "Description": "Buffing or slack action excessive, train handling",
        "Category": "Train Handling / Train Make-Up",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 368,
        "Code": "H504",
        "Description": "Buffing or slack action excessive, train make‑up",
        "Category": "Train Handling / Train Make-Up",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 369,
        "Code": "H505",
        "Description": "Lateral drawbar force on curve excessive, train handling",
        "Category": "Train Handling / Train Make-Up",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 370,
        "Code": "H506",
        "Description": "Lateral drawbar force on curve excessive, train make‑up",
        "Category": "Train Handling / Train Make-Up",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 371,
        "Code": "H507",
        "Description": "Lateral drawbar force on curve excessive, car geometry (short car/long car combination)",
        "Category": "Train Handling / Train Make-Up",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 372,
        "Code": "H508",
        "Description": "Improper train make‑up",
        "Category": "Train Handling / Train Make-Up",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 373,
        "Code": "H509",
        "Description": "Improper train inspection",
        "Category": "Train Handling / Train Make-Up",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 374,
        "Code": "H510",
        "Description": "Automatic brake, insufficient (H001) -- see note after cause H599",
        "Category": "Train Handling / Train Make-Up",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 375,
        "Code": "H511",
        "Description": "Automatic brake, excessive (H002)",
        "Category": "Train Handling / Train Make-Up",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 376,
        "Code": "H512",
        "Description": "Automatic brake, failure to use split reduction (H003)",
        "Category": "Train Handling / Train Make-Up",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 377,
        "Code": "H513",
        "Description": "Automatic brake, other improper use (H004)",
        "Category": "Train Handling / Train Make-Up",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 378,
        "Code": "H514",
        "Description": "Failure to allow air brakes to fully release before proceeding (H005)",
        "Category": "Train Handling / Train Make-Up",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 379,
        "Code": "H515",
        "Description": "Failure to properly cut‑out brake valves on locomotives (H006)",
        "Category": "Train Handling / Train Make-Up",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 380,
        "Code": "H516",
        "Description": "Failure to properly cut‑in brake valves on locomotives (H007)",
        "Category": "Train Handling / Train Make-Up",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 381,
        "Code": "H517",
        "Description": "Dynamic brake, insufficient (H009)",
        "Category": "Train Handling / Train Make-Up",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 382,
        "Code": "H518",
        "Description": "Dynamic brake, excessive (H010)",
        "Category": "Train Handling / Train Make-Up",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 383,
        "Code": "H519",
        "Description": "Dynamic brake, too rapid adjustment (H011)",
        "Category": "Train Handling / Train Make-Up",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 384,
        "Code": "H520",
        "Description": "Dynamic brake, excessive axles (H012)",
        "Category": "Train Handling / Train Make-Up",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 385,
        "Code": "H521",
        "Description": "Dynamic brake, other improper use (H013)",
        "Category": "Train Handling / Train Make-Up",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 386,
        "Code": "H522",
        "Description": "Throttle (power), improper use (H014)",
        "Category": "Train Handling / Train Make-Up",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 387,
        "Code": "H523",
        "Description": "Throttle (power), too rapid adjustment (H015)",
        "Category": "Train Handling / Train Make-Up",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 388,
        "Code": "H524",
        "Description": "Excessive horsepower (H016)",
        "Category": "Train Handling / Train Make-Up",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 389,
        "Code": "H525",
        "Description": "Independent (engine) brake, improper use (except actuation) (H023)",
        "Category": "Train Handling / Train Make-Up",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 390,
        "Code": "H526",
        "Description": "Failure to actuate off independent brake (H024)",
        "Category": "Train Handling / Train Make-Up",
        "Title": "Train operation - Human Factors"
    },
    {
        id: 391,
        "Code": "H599",
        "Description": "Other causes relating to train handling or makeup (Provide detailed description in narrative)",
        "Category": "Train Handling / Train Make-Up",
        "Title": "Train operation - Human Factors"
    },
]


export const NullCheckForTable = (value) => (value == '' || !value) ? 'NA' : value